import React, { useEffect, useState } from 'react';
import styles from './navbar.module.css'; // Importing the CSS module
import { useNavigate } from 'react-router-dom';
import { Paginationright } from '../../../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCatThunk } from '../../../redux/appearancesSlice';

const Navbar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const dispacth = useDispatch()
    const { categories, loading } = useSelector((state) => state.appearences)
    const [showsubcategories, setShowSubcategories] = useState(false)
    const [showLevel3categories, setshowLevel3categories] = useState(false)
    const [selectedSubcategories, setSelectedSubcategories] = useState([])
    const [selectedLevel3cat, setSelectedLevel3cat] = useState([])
    const [activeCat, setActivecat] = useState(null)
    const [activesub, setActivesub] = useState(null)

    const navigate = useNavigate()
    const handleMouseEnter = (menu) => {
        setActiveDropdown(menu);
    };

    const handleMouseLeave = () => {
        setActiveDropdown(null);
    };


    useEffect(() => {
        dispacth(getAllCatThunk())
    }, [])


    // console.log(categories);
    const handlecatover = (id) => {
        setActivecat(id)
        setActivesub(null)
        setShowSubcategories(true)
        setshowLevel3categories(false)
        const filter = categories?.subcategories?.filter((i) => i?.parentId == id)
        setSelectedSubcategories(filter)
    }


    const handlesubcatover = (id) => {
        setActivesub(id)
        setshowLevel3categories(true)
        const filter = categories?.level3categories?.filter((i) => i?.parentId == id)
        setSelectedLevel3cat(filter)
    }

    return (
        <nav className={styles.navbar}>
            <ul className={styles.navbarList}>
                <li
                    className={styles.navbarItem}
                    onMouseEnter={() => handleMouseEnter('products')}
                    onMouseLeave={handleMouseLeave}

                >
                    Products
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3_90650)">
                            <path d="M7 9.33203L3.5 5.83203H10.5L7 9.33203Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_3_90650">
                                <rect width="14" height="14" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>

                    {activeDropdown === 'products' && (
                        <div className={styles.catbox} onMouseLeave={() => { setShowSubcategories(false); setActivecat(null); }}>
                            <div className={styles.catdropdown}>
                                <ul>
                                    {categories?.categories?.slice(0, 10).map((i) => (
                                        <li
                                            key={i?._id}
                                            onMouseEnter={() => handlecatover(i?._id)}
                                            className={activeCat === i?._id ? styles.activecat : ''}
                                            onClick={() => navigate(`/subcategories/${activeCat}`)}
                                        >
                                            {i?.name} {i?.subcategoryCount > 0 && Paginationright()}
                                        </li>
                                    ))}
                                    {categories?.categories?.length > 10 && (
                                        <li
                                            className={styles.viewAll}
                                            onClick={() => navigate(`/categories`)}
                                        >
                                            View All
                                        </li>
                                    )}
                                </ul>
                            </div>

                            {showsubcategories && selectedSubcategories?.length > 0 && (
                                <div className={styles.catdropdown}>
                                    <ul>
                                        {selectedSubcategories.slice(0, 10).map((i) => (
                                            <li
                                                key={i?._id}
                                                onMouseEnter={() => handlesubcatover(i?._id)}
                                                className={activesub === i?._id ? styles.activecat : ''}
                                            >
                                                {i?.name} {i?.level3CategoryCount > 0 && Paginationright()}
                                            </li>
                                        ))}
                                        {selectedSubcategories.length > 10 && (
                                            <li
                                                className={styles.viewAll}
                                                onClick={() => navigate(`/subcategories/${activeCat}`)}
                                            >
                                                View All
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}

                            {showLevel3categories && selectedLevel3cat?.length > 0 && (
                                <div className={styles.catdropdown}>
                                    <ul>
                                        {selectedLevel3cat.slice(0, 10).map((i) => (
                                            <li 
                                            key={i?._id} 
                                            onClick={() => navigate(`/productList/${activeCat}`)}
                                            >
                                                {i?.name}
                                                </li>
                                        ))}
                                        {selectedLevel3cat.length > 10 && (
                                            <li
                                                className={styles.viewAll}
                                                onClick={() => navigate(`/subcategories/${activeCat}`)}
                                            >
                                                View All
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}

                </li>

                <li
                    className={styles.navbarItem}
                  onClick={()=>navigate('/manufacturers')}
                >
                    Manufacturers

                </li>

                <li
                    className={styles.navbarItem}
                    onMouseEnter={() => handleMouseEnter('tools')}
                    onMouseLeave={handleMouseLeave}
                >
                    Tools
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3_90650)">
                            <path d="M7 9.33203L3.5 5.83203H10.5L7 9.33203Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_3_90650">
                                <rect width="14" height="14" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    {activeDropdown === 'tools' && (
                        <div className={styles.dropdown}>
                            <ul>
                                <li onClick={()=>navigate('/bomManage')}>BOM Tool</li>
                                <li onClick={() => navigate('/crossRefer')}>Cross Reference Tool</li>
                                <li onClick={() => navigate('/exInventoryBuyItem')}>Excess Inventory  tool</li>
                                <li onClick={() => navigate('/scheduleCart')}>Schedule  tool</li>
                                <li onClick={() => navigate('/wizardUpload')}>Wizard Tool</li>
                            </ul>
                        </div>
                    )}
                </li>

                <li className={styles.navbarItem} onClick={() => navigate('/service')}>Services</li>

                <li
                    className={styles.navbarItem}
                    onMouseEnter={() => handleMouseEnter('more')}
                    onMouseLeave={handleMouseLeave}
                >
                    More
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3_90650)">
                            <path d="M7 9.33203L3.5 5.83203H10.5L7 9.33203Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_3_90650">
                                <rect width="14" height="14" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    {activeDropdown === 'more' && (
                        <div className={styles.dropdown}>
                            <ul>
                                <li onClick={() => navigate('/aboutUs')}>About Us</li>
                                <li onClick={() => navigate('/contact')}>Contact</li>
                                <li >Careers</li>
                            </ul>
                        </div>
                    )}
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
